<template>
  <v-layout>
    <v-flex xs12>
      <v-card>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">{{ detail.name }}</h3>
            <div v-html="detail.description"></div>
          </div>
        </v-card-title>
        <v-card-actions v-if="detail.type == 'well'">
          <v-btn flat color="blue" @click="mOpenDetailDialog(detail)">Well Details</v-btn>
          <v-btn flat color="orange">Watch Well</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-btn flat color="blue" @click="zoomed">Zoom Into</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const oilNamespace = createNamespacedHelpers("oil");

export default {
  props: ["detail"],
  data() {
    return {};
  },
  methods: {
    ...oilNamespace.mapMutations(["mOpenDetailDialog", "mCloseDetailDialog"]),
    zoomed() {
      const center = { ...this.detail.position };
      const params = {
        center,
        zoomLevel: 8,
      };
      this.$emit("zoomed", params);
    },
  },
};
</script>